import { render, staticRenderFns } from "./edit-clinic.vue?vue&type=template&id=206c0ab2&"
import script from "./edit-clinic.vue?vue&type=script&lang=js&"
export * from "./edit-clinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports